"use strict";

import { Validator } from "vee-validate";
import strings from "@/assets/i18n/strings.json";
import es from "vee-validate/dist/locale/es";
import en from "vee-validate/dist/locale/en";
import { default as config } from "./config";
import moment from "moment";

function loadResxSync(lang) {
  return {
    labels: getStringValuesSync("labels", lang || config.state.defaultLang),
    messages: getStringValuesSync("messages", lang || config.state.defaultLang)
  };
}

function getStringValuesSync(prop, lang) {
  let values = {};
  let keys = Object.keys(strings[prop]);
  keys.forEach(key => {
    if (strings[prop][key][lang]) {
      values[key] = strings[prop][key][lang];
    } else {
      values[key] =
        process.env.NODE_ENV === "production" ||
        process.env.NODE_ENV === "staging"
          ? key
          : `Translate for key '${key}' not found for language '${lang}'`;
    }
  });
  return values;
}

const validateLocales = {
  es: es,
  en: en
};

const dateFormats = {
  es: {
    short: "DD/MM/YYYY, HH:mm",
    medium: "MMM DD, YYYY HH:mm:ss",
    shortDate: "DD/MM/YYYY",
    mediumDate: "MMM DD, YYYY",
    longDate: "MMMM DD, YYYY",
    fullDate: "dddd, MMMM DD, YYYY",
    shortTime: "HH:mm A",
    mediumTime: "HH:mm:ss"
  },
  en: {
    short: "M/D/YY, h:mm a",
    medium: "MMM D, YY h:mm:ss a",
    shortDate: "M/D/YY",
    mediumDate: "MMM D, YY",
    longDate: "MMMM D, YY",
    fullDate: "dddd, MMMM D, YY",
    shortTime: "h:mm a",
    mediumTime: "h:mm:ss a"
  }
};

const state = {
  lang: config.state.defaultLang,
  dateFormats: dateFormats[config.state.defaultLang],
  resx: loadResxSync(config.state.defaultLang)
};

const mutations = {
  changeLang: (state, lang) => {
    moment.locale(lang);
    state.lang = lang;
    state.resx = loadResxSync(lang);
    state.dateFormats = dateFormats[lang];
    Validator.localize(lang, validateLocales[lang]);
  }
};

Validator.localize(
  config.state.defaultLang,
  validateLocales[config.state.defaultLang]
);

export default { state, mutations };
